import { TooltipProps } from "recharts";
import {
    NameType,
    ValueType,
} from "recharts/types/component/DefaultTooltipContent";

interface MarketInsightsChartTooltipProps extends TooltipProps<ValueType, NameType> {
    unit?: string | Record<string, string>;
}

export function MarketInsightsChartTooltip({
    active,
    payload,
    label,
    unit = "$",
}: MarketInsightsChartTooltipProps) {
    const getUnit = (seriesName: string) => {
        if (typeof unit === "string") {
            return unit;
        }
        return unit[seriesName] || "";
    };

    if (active && payload && payload.length) {
        return (
            <div
                className="bg-white dark:bg-gray-800 p-3 rounded shadow-lg border border-gray-200 dark:border-gray-700 min-w-[8rem]"
                style={{ opacity: 0.75 }}
            >
                <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                    {label}
                </p>
                {payload.map((entry, index) => {
                    const entryUnit = getUnit(entry.name as string);
                    return (
                        <div key={`item-${index}`} className="flex items-center gap-1.5">
                            <div
                                className="w-2 h-2 shrink-0 rounded-[2px]"
                                style={{
                                    backgroundColor: entry.color,
                                    height: "0.5rem",
                                }}
                            />
                            <div className="flex justify-between w-full min-w-[6rem]">
                                <span className="text-sm text-gray-700 dark:text-gray-300 pr-2">
                                    {entry.name}
                                </span>
                                <span className="text-sm text-gray-950 dark:text-gray-50 pl-2">
                                    {entryUnit === "$" ? `$${entry.value}` : entryUnit === "%" ? `${entry.value}%` : `${entry.value} ${entryUnit}`}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    return null;
} 